module.exports = __webpack_public_path__ + "img/cxcg.cb2aaee5.jpg";